import { Component, Input, OnInit } from '@angular/core';
import { DossierService } from '../../../services/dossier.service';
import { Globals } from 'projects/core/src/globals';

@Component({
  selector: 'app-preview',
  templateUrl: './preview.component.html',
  styleUrl: './preview.component.css'
})
export class PreviewComponent implements OnInit {
  @Input()
  record:any;

  tab=0;

  constructor(private dossierService: DossierService){}
  ngOnInit(): void {
    this.dossierService.getItem(this.record.id).subscribe((result)=>{
      
      
      for(let p of result.phases){
        for(let s of p.sections){
          for(let f of s.fields){
            if(f.type=='file' && f.value){
              f.value=JSON.parse(f.value);
            }
          }
        }
      }
      
      this.record=result;
      
    })
    
  }

  getPhaseStatus(id_phase:number,phase:any){
    //esplora i log e trova l'ultimo stato di una fase
    let state={state: 0};
    if(this.record.log && this.record.log.length>0){
     
      for(let l of this.record.log){
        if(l['id_phase']==id_phase){
          state=l;
          if(phase)
            phase['state']=state;
        }
      }
    }
   
    return state;


  }

  calculateFormula(formula,fields){
    
    // sostituisci nella formula i valori degli altri campi
    for(let f of fields){
      formula=formula.replaceAll("{{"+f.name+"}}",f.value);
    }
    const result=eval(formula);
    return result;   

  }
  

  checkEnableCondition(fields,enable_condition_fieldname){
    
    if(enable_condition_fieldname){
      for(let f of fields){
        if(f.name==enable_condition_fieldname){
          if(f.value=='' || f.value==0 || f.value==undefined || f.value==null){
            return false;
          }
    
        }
      }
    }

    return true;
  }
  

  close(){
    this['modalWindow'].close();
  }

  getBasePath(path:string){
      if(path)
        return Globals.config.serverUrl+"/"+path;
      return "";
    }

  downloadFile(relative_path:string){
    window.open( this.getBasePath(relative_path),"_blank");
  }

}
